import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import { Navbar, NavbarBrand } from 'reactstrap';
import { useAppContext } from '@front-activerse/common-components';
import { Link } from 'react-router-dom';

const Header = () => {
  const { t } = useTranslator();

  const {
    images: { logo, signet },
  } = useAppContext();

  return (
    <header className="mb-auto main-menu">
      <Navbar light expand="lg" container>
        <NavbarBrand className="mx-auto" tag={Link} to={import.meta.env.VITE_LANDING_PAGE_URL}>
          <img
            src={logo}
            alt={t('app.default.navbarTitle')}
            style={{ maxWidth: '155px', maxHeight: '46px' }}
            className="d-none d-md-block"
          />
          <img
            src={signet}
            alt={t('app.default.navbarTitle')}
            style={{ maxHeight: '44px' }}
            className="d-md-none"
          />
        </NavbarBrand>
      </Navbar>
    </header>
  );
};

export default Header;
